module.exports = __webpack_public_path__ + "img/p4-img1-d1-2.0339ee6c.png";